import { render } from "./FileInputQr.vue?vue&type=template&id=2d6f84cd"
import script from "./FileInputQr.vue?vue&type=script&lang=js"
export * from "./FileInputQr.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/inv/inertia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__